import { ToastContainer } from '@lokalise/louis';
import type { FC, ReactNode } from 'react';

import bird from './assets/static/bird.png';
import wolf from './assets/static/wolf.png';
import { Container, LeftImage, RightImage, Wrapper } from './styles';

type BackgroundWrapperProps = {
    children: ReactNode;
};

const BackgroundWrapper: FC<BackgroundWrapperProps> = ({ children }) => (
    <>
        <Wrapper>
            <LeftImage src={wolf} alt="Onboarding Visual Wolf" />
            <RightImage src={bird} alt="Onboarding Visual Bird" />
        </Wrapper>
        <Container>{children}</Container>
        <ToastContainer />
    </>
);

export default BackgroundWrapper;
